import React from "react";
const OddSectionSkeleton = () => {
    return (
        <div id="app">
            <div className="d-block match-detail">
                <div className="inplay-tableblock odds-table-section table-responsive first">
                    <div
                        id="marketBetsWrap"
                        className="bets-wrap asiahadicap"
                    >
                        <span
                            data-tooltip-id="info-icon"
                            id="info-icon"
                            className="bet-limit info-icon"
                        ></span>
                        <dl
                            id="betsHead"
                            className="bets-selections-head"
                        >
                            <dt>
                                <a
                                    className="a-depth"
                                    id="marketDepthBtn"
                                >
                                    Markets Depth
                                </a>
                                <p>
                                    <span>Matched 2</span>
                                    <strong id="totalMatched">
                                        -
                                    </strong>
                                </p>
                            </dt>
                            <dd>Back </dd>
                            <dd>Lay </dd>
                        </dl>
                    </div>

                    <table
                        className="table custom-table inplay-table w1-table"
                    >
                        <tbody>
                            <tr className="betstr">
                                <td className="text-color-grey opacity-1">
                                    <span className="totselection seldisplay">
                                        2 Selections
                                    </span>
                                </td>
                                <td colSpan={2}>101.7%</td>
                                <td>
                                    <span>Back</span>
                                </td>{" "}
                                <td>
                                    <span>Lay</span>
                                </td>
                                <td colSpan={2}>97.9%</td>
                            </tr>


                            <>
                                <tr className="bg-white tr-odds tr_team1 odds-skeleton" >
                                    <td>
                                        {/* <img src="../../../images/bars.png" /> */}
                                        <b className="team1">

                                        </b>
                                    </td>
                                    <td
                                        className={`light-blue-bg-2 opnForm ODDSBack td_team1_back_2 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="back1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td

                                        className={`light-blue-bg-3 ODDSBack td_team1_back_1 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="back1btn text-color-black">
                                            {" "}
                                            -- <br />

                                        </a>
                                    </td>
                                    <td

                                        className={`cyan-bg ODDSBack td_team1_back_0 odds-skeleton-padding`}
                                        // style={{ paddingTop: "20px" }}
                                        style={{ lineHeight: 1.3, padding: "0px !important" }}
                                    >
                                        <a className="back1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td
                                        className={` pink-bg ODDSLay td_team1_lay_0 odds-skeleton-padding `}
                                        // style={{ paddingTop: "20px" }}
                                        style={{ lineHeight: 1.3, padding: "0px !important" }}
                                    >
                                        <a className="lay1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td
                                        className={` light-pink-bg-2 ODDSLay td_team1_lay_1 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="lay1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td

                                        className={` light-pink-bg-3 ODDSLay td_team1_lay_2 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="lay1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                </tr>
                            </>
                            <>
                                <tr className="bg-white tr-odds tr_team1 odds-skeleton" >
                                    <td>
                                        {/* <img src="../../../images/bars.png" /> */}
                                        <b className="team1">

                                        </b>
                                    </td>
                                    <td
                                        className={`light-blue-bg-2 opnForm ODDSBack td_team1_back_2 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="back1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td

                                        className={`light-blue-bg-3 ODDSBack td_team1_back_1 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="back1btn text-color-black">
                                            {" "}
                                            -- <br />

                                        </a>
                                    </td>
                                    <td

                                        className={`cyan-bg ODDSBack td_team1_back_0 odds-skeleton-padding`}
                                        // style={{ paddingTop: "20px" }}
                                        style={{ lineHeight: 1.3, padding: "0px !important" }}
                                    >
                                        <a className="back1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td
                                        className={` pink-bg ODDSLay td_team1_lay_0 odds-skeleton-padding `}
                                        // style={{ paddingTop: "20px" }}
                                        style={{ lineHeight: 1.3, padding: "0px !important" }}
                                    >
                                        <a className="lay1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td
                                        className={` light-pink-bg-2 ODDSLay td_team1_lay_1 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="lay1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                    <td

                                        className={` light-pink-bg-3 ODDSLay td_team1_lay_2 odds-skeleton-padding`} style={{ padding: "0px !important" }}
                                    >
                                        <a className="lay1btn text-color-black">
                                            {" "}
                                            -- <br />
                                        </a>
                                    </td>
                                </tr>
                            </>

                        </tbody>
                    </table>
                </div>


            </div>
        </div>
    )
}

export default OddSectionSkeleton;